import { render } from "./OversightTable.vue?vue&type=template&id=6a6fdd5e"
import script from "./OversightTable.vue?vue&type=script&lang=js"
export * from "./OversightTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__